import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import SmokeContainer from "./SmokeContainer";
// import Typing from "./React-Typing-Animation";
import "../styles/login.scss";

const NotFound = () => (
  <SmokeContainer>
    <Helmet>
      <title>404 Not Found</title>
    </Helmet>
    <audio
      src="https://cdn.chorusproductions.com/eschaton-v2/typing/ei_drone2.mp3"
      preload="auto"
      autoPlay
      loop
    ></audio>
    <div className="typewriter-text">
      <div className="console">
        <p className="typing error">
          Error...<br />
          It looks like you're in the wrong place.<br />
          Please <Link className="link" to="/home">return to Eschaton</Link>.
        </p>
      </div>
    </div>
  </SmokeContainer>
);

export default NotFound;
